import { Alert, Button } from "react-bootstrap";
import { Modal } from "../../../components";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { useEffect } from "react";
import { useGeneralAppStore } from "../../../store/generalAppStore";

const ModalVerAviso = () => {

    //? ESTADOS GLOBALES
    const { alertasBloqueo, alertasNoBloqueo , archivos } = useActaDetalleStore();
    const { modals, handlerModal } = useGeneralAppStore();



    useEffect(() => {
        return () => {
            handlerModal({ modal: false, modalName: "ver_aviso" })
        }
    }, [])

    return (
        <>
            <Modal
                show={modals.includes('ver_aviso')}
                size={"lg"}
                onHide={() => handlerModal({ modal: false, modalName: "ver_aviso" })}
                title={() => "Aviso de visita"}
            >

                <object data={archivos?.aviso?.file} type="application/pdf" className="w-100" style={{aspectRatio:"3/4"}}></object>
            </Modal>
        </>
    );
}
export default ModalVerAviso;